"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudiencePickerProvider = void 0;
var _react = require("react");
var _hooks = require("./hooks");
var _hooks2 = require("../../../hooks");
var _urls = require("../../../utilities/urls");
var _AudiencePickerProvider = require("./AudiencePickerProvider.helpers");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var emptyArray = [];
var useAudiencePickerProvider = function useAudiencePickerProvider(props) {
  var _props$teacherIds = props.teacherIds,
    teacherIds = _props$teacherIds === void 0 ? emptyArray : _props$teacherIds,
    _props$schoolId = props.schoolId,
    schoolId = _props$schoolId === void 0 ? null : _props$schoolId,
    _props$environmentID = props.environmentID,
    environmentID = _props$environmentID === void 0 ? null : _props$environmentID,
    _props$audienceID = props.audienceID,
    audienceID = _props$audienceID === void 0 ? null : _props$audienceID,
    _props$isReadOnly = props.isReadOnly,
    isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
    _props$readOnlyGroups = props.readOnlyGroups,
    readOnlyGroups = _props$readOnlyGroups === void 0 ? emptyArray : _props$readOnlyGroups,
    _props$readOnlyStuden = props.readOnlyStudents,
    readOnlyStudents = _props$readOnlyStuden === void 0 ? emptyArray : _props$readOnlyStuden,
    _props$selectedGroups = props.selectedGroups,
    selectedGroups = _props$selectedGroups === void 0 ? emptyArray : _props$selectedGroups,
    _props$selectedStuden = props.selectedStudents,
    selectedStudents = _props$selectedStuden === void 0 ? emptyArray : _props$selectedStuden,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? null : _props$onClose,
    _props$onDisableItemC = props.onDisableItemClick,
    onDisableItemClick = _props$onDisableItemC === void 0 ? null : _props$onDisableItemC,
    _props$onDeleteItem = props.onDeleteItem,
    onDeleteItem = _props$onDeleteItem === void 0 ? null : _props$onDeleteItem,
    _props$onChanged = props.onChanged,
    onChanged = _props$onChanged === void 0 ? null : _props$onChanged,
    fullHeight = props.fullHeight;
  var _useSessionData = (0, _hooks2.useSessionData)(),
    isSessionDataReady = _useSessionData.isSessionDataReady,
    userId = _useSessionData.userId,
    role = _useSessionData.role,
    sessionSchoolId = _useSessionData.schoolId;
  var _useCetEvents = (0, _hooks2.useCetEvents)(),
    sendUiUsageEvent = _useCetEvents.sendUiUsageEvent;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAudiencePickerProviderReady = _useState2[0],
    setIsAudiencePickerProviderReady = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    audienceData = _useState6[0],
    setAudienceData = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    groupsMapper = _useState8[0],
    setGroupsMapper = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    classesMapper = _useState10[0],
    setClassesMapper = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    singleStudentsMapper = _useState12[0],
    setSingleStudentsMapper = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    studentsMapper = _useState14[0],
    setStudentsMapper = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    groupsIds = _useState16[0],
    setGroupsIds = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    classesIds = _useState18[0],
    setClassesIds = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    singleStudentsIds = _useState20[0],
    setSingleStudentsIds = _useState20[1];
  var _useState21 = (0, _react.useState)([]),
    _useState22 = _slicedToArray(_useState21, 2),
    studentsIds = _useState22[0],
    setStudentsIds = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isNoAudience = _useState24[0],
    setIsNoAudience = _useState24[1];
  var _useState25 = (0, _react.useState)('classes'),
    _useState26 = _slicedToArray(_useState25, 2),
    groupType = _useState26[0],
    setGroupType = _useState26[1];
  var _useState27 = (0, _react.useState)('create_group_error_title'),
    _useState28 = _slicedToArray(_useState27, 2),
    createGroupErrorMessage = _useState28[0],
    setCreateGroupErrorMessage = _useState28[1];
  var _useState29 = (0, _react.useState)(''),
    _useState30 = _slicedToArray(_useState29, 2),
    cantRemoveMessage = _useState30[0],
    setCantRemoveMessage = _useState30[1];
  var _useView = (0, _hooks.useView)(),
    view = _useView.view,
    viewIndex = _useView.viewIndex,
    setViewAndIndex = _useView.setViewAndIndex,
    isErrorMessage = _useView.isErrorMessage;
  var _useReadOnly = (0, _hooks.useReadOnly)(readOnlyGroups, readOnlyStudents),
    readOnlyGroupsMapper = _useReadOnly.readOnlyGroupsMapper,
    readOnlyStudentsMapper = _useReadOnly.readOnlyStudentsMapper;
  var _useSelected = (0, _hooks.useSelected)(selectedGroups, selectedStudents, classesMapper, groupsMapper, studentsMapper, onChanged),
    originalSelectedGroupsIds = _useSelected.originalSelectedGroupsIds,
    originalSelectedClassesIds = _useSelected.originalSelectedClassesIds,
    originalSelectedStudentsIds = _useSelected.originalSelectedStudentsIds,
    selectedGroupsIds = _useSelected.selectedGroupsIds,
    setSelectedGroupsIds = _useSelected.setSelectedGroupsIds,
    selectedClassesIds = _useSelected.selectedClassesIds,
    selectedStudentsIds = _useSelected.selectedStudentsIds,
    setSelectedStudentsIds = _useSelected.setSelectedStudentsIds,
    getSelectedGroupsAndStudentsData = _useSelected.getSelectedGroupsAndStudentsData,
    onSelectedChanged = _useSelected.onSelectedChanged;
  var _useTempData = (0, _hooks.useTempData)(studentsIds, singleStudentsIds, classesMapper, groupsMapper, studentsMapper),
    groupsSelectorTempData = _useTempData.groupsSelectorTempData,
    setGroupsSelectorTempData = _useTempData.setGroupsSelectorTempData,
    studentsSelectorTempData = _useTempData.studentsSelectorTempData,
    setStudentsSelectorTempData = _useTempData.setStudentsSelectorTempData,
    createGroupTempData = _useTempData.createGroupTempData,
    setCreateGroupTempData = _useTempData.setCreateGroupTempData,
    getStudentsSearchList = _useTempData.getStudentsSearchList;
  var userIds = (0, _react.useMemo)(function () {
    return isSessionDataReady && userId && role && ['teacher', 'coordinator', 'admin'].indexOf(role) >= 0 ? (teacherIds === null || teacherIds === void 0 ? void 0 : teacherIds.length) > 0 ? _toConsumableArray(teacherIds) : [userId] : [];
  }, [isSessionDataReady, role, teacherIds, userId]);
  var itemSchoolId = (0, _react.useMemo)(function () {
    return isSessionDataReady && userId && role && ['teacher', 'coordinator', 'admin'].indexOf(role) >= 0 ? schoolId || sessionSchoolId : null;
  }, [isSessionDataReady, role, schoolId, sessionSchoolId, userId]);
  (0, _react.useEffect)(function () {
    if (userIds && userIds.length > 0 && itemSchoolId) {
      var mappers = {
        groups: {},
        classes: {},
        singleStudents: {},
        students: {}
      };
      setIsLoading(true);
      Promise.all(userIds.map(function (userId) {
        return fetch("".concat(_urls.ofakimApiUrl, "/lmscp/getTeacherGroupsAndStudents?schoolID=").concat(itemSchoolId, "&userID=").concat(userId, "&environmentID=").concat(environmentID), {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          referrerPolicy: 'no-referrer',
          credentials: 'include',
          redirect: 'follow'
        }).then(function (response) {
          return response.json();
        }).then(function (groups) {
          return groups && groups.value && groups.value.length > 0 ? groups.value : [];
        }).then(function (groups) {
          if (audienceID) {
            setAudienceData((0, _AudiencePickerProvider.getAudienceData)(groups, audienceID));
          }
          groups.forEach(function (group) {
            var _group$students;
            (0, _AudiencePickerProvider.mapClassesAndGroups)(group, userId, mappers);
            if (((_group$students = group.students) === null || _group$students === void 0 ? void 0 : _group$students.length) > 0) {
              (0, _AudiencePickerProvider.mapStudents)(group, mappers);
              (0, _AudiencePickerProvider.sortClassesAndGroupsStudents)(group, mappers);
            }
          });
          return {
            userId: userId,
            groups: groups
          };
        }).catch(function (error) {
          console.error(error);
          return {
            userId: userId,
            groups: []
          };
        });
      })).then(function () {
        setClassesMapper(mappers.classes);
        setGroupsMapper(mappers.groups);
        setSingleStudentsMapper(mappers.singleStudents);
        setStudentsMapper(mappers.students);
        setClassesIds((0, _AudiencePickerProvider.sortByGroupName)(mappers.classes));
        setGroupsIds((0, _AudiencePickerProvider.sortByGroupName)(mappers.groups));
        setSingleStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(mappers.singleStudents));
        setStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(mappers.students));
        setIsAudiencePickerProviderReady(true);
        setIsLoading(false);
      });
    } else {
      setClassesMapper(null);
      setGroupsMapper(null);
      setSingleStudentsMapper(null);
      setStudentsMapper(null);
      setClassesIds([]);
      setGroupsIds([]);
      setSingleStudentsIds([]);
      setStudentsIds([]);
      setIsAudiencePickerProviderReady(false);
      setIsLoading(false);
    }
  }, [audienceID, environmentID, itemSchoolId, userIds]);
  (0, _react.useEffect)(function () {
    if (isAudiencePickerProviderReady) {
      setIsNoAudience((classesIds === null || classesIds === void 0 ? void 0 : classesIds.length) === 0 && (groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.length) === 0 && (studentsIds === null || studentsIds === void 0 ? void 0 : studentsIds.length) === 0);
    }
  }, [classesIds, classesIds === null || classesIds === void 0 ? void 0 : classesIds.length, groupsIds, groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.length, isAudiencePickerProviderReady, studentsIds, studentsIds === null || studentsIds === void 0 ? void 0 : studentsIds.length]);
  (0, _react.useEffect)(function () {
    var newGroupType = groupType;
    if (groupType === 'classes' && !((classesIds === null || classesIds === void 0 ? void 0 : classesIds.length) > 0) && (groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.length) > 0) {
      newGroupType = 'groups';
    } else if (groupType === 'groups' && !((groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.length) > 0) && (classesIds === null || classesIds === void 0 ? void 0 : classesIds.length) > 0) {
      newGroupType = 'classes';
    }
    if (newGroupType !== groupType) {
      setGroupType(newGroupType);
    }
  }, [classesIds === null || classesIds === void 0 ? void 0 : classesIds.length, groupType, groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.length]);
  var saveGroup = (0, _react.useCallback)(function (goToView, goToViewIndex, goToErrorView, goToErrorViewIndex) {
    var isSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var promise = new Promise(function (resolve, reject) {
      if (itemSchoolId && (userIds === null || userIds === void 0 ? void 0 : userIds.length) > 0 && studentsSelectorTempData.selectedStudentsIds && studentsSelectorTempData.selectedStudentsIds.length > 0 && createGroupTempData.groupName) {
        fetch("".concat(_urls.ofakimApiUrl, "/lmscp/createGroup"), {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          referrerPolicy: 'no-referrer',
          credentials: 'include',
          redirect: 'follow',
          body: JSON.stringify({
            schoolID: itemSchoolId,
            groupName: createGroupTempData.groupName,
            studentIDs: studentsSelectorTempData.selectedStudentsIds,
            teacherIDs: userIds
          })
        }).then(function (response) {
          return response.json();
        }).then(function (group) {
          var value = group && group.value;
          if (value) {
            if (audienceID) {
              audienceData === null || audienceData === void 0 ? void 0 : audienceData.Groups.push(value.id);
              fetch("".concat(_urls.ofakimApiUrl, "/lmscp/upsertAudience"), {
                method: 'POST',
                mode: 'cors',
                headers: {
                  'Content-Type': 'application/json'
                },
                referrerPolicy: 'no-referrer',
                credentials: 'include',
                redirect: 'follow',
                body: JSON.stringify(audienceData)
              }).catch(function (error) {});
            }
            resolve(value);
          } else {
            reject(group);
          }
        }).catch(function (error) {
          reject(error);
        });
      } else {
        reject();
      }
    });
    promise.then(function (group) {
      sendUiUsageEvent({
        category: 'assignActivity',
        label: 'ConfirmNewGroup'
      });
      var _groupsMapper = (0, _AudiencePickerProvider.updateGroupsMapper)(group, groupsMapper, userIds, studentsSelectorTempData);
      var _studentsMapper = (0, _AudiencePickerProvider.updateStudentsMapper)(group, studentsMapper, _groupsMapper, studentsSelectorTempData);
      setGroupsMapper(_groupsMapper);
      setStudentsMapper(_studentsMapper);
      setGroupsIds((0, _AudiencePickerProvider.sortByGroupName)(_groupsMapper));
      setStudentsIds((0, _AudiencePickerProvider.sortByStudentFullName)(_studentsMapper));
      if (isSelected) {
        if (selectedGroupsIds.indexOf(group.id) < 0) {
          setSelectedGroupsIds([group.id].concat(_toConsumableArray(selectedGroupsIds)));
          setSelectedStudentsIds(selectedStudentsIds.filter(function (id) {
            return studentsSelectorTempData.selectedStudentsIds.indexOf(id) < 0;
          }));
        }
      }
      setViewAndIndex(goToView, goToViewIndex);
    }).catch(function (error) {
      var errorMessage = error && error.description === 'Group name already exists' ? 'create_group_name_exists_error_title' : 'create_group_error_title';
      setCreateGroupErrorMessage(errorMessage);
      setViewAndIndex(goToErrorView, goToErrorViewIndex);
    });
  }, [audienceData, audienceID, createGroupTempData.groupName, groupsMapper, itemSchoolId, selectedGroupsIds, selectedStudentsIds, sendUiUsageEvent, setSelectedGroupsIds, setSelectedStudentsIds, setViewAndIndex, studentsMapper, studentsSelectorTempData, userIds]);
  return {
    isAudiencePickerProviderReady: isAudiencePickerProviderReady,
    isLoading: isLoading,
    isNoAudience: isNoAudience,
    userIds: userIds,
    itemSchoolId: itemSchoolId,
    audienceData: audienceData,
    environmentID: environmentID,
    classesMapper: classesMapper,
    groupsMapper: groupsMapper,
    studentsMapper: studentsMapper,
    singleStudentsMapper: singleStudentsMapper,
    groupsIds: groupsIds,
    classesIds: classesIds,
    singleStudentsIds: singleStudentsIds,
    studentsIds: studentsIds,
    isReadOnly: isReadOnly,
    readOnlyGroupsMapper: readOnlyGroupsMapper,
    readOnlyStudentsMapper: readOnlyStudentsMapper,
    originalSelectedGroupsIds: originalSelectedGroupsIds,
    originalSelectedClassesIds: originalSelectedClassesIds,
    originalSelectedStudentsIds: originalSelectedStudentsIds,
    selectedGroupsIds: selectedGroupsIds,
    selectedClassesIds: selectedClassesIds,
    selectedStudentsIds: selectedStudentsIds,
    getSelectedGroupsAndStudentsData: getSelectedGroupsAndStudentsData,
    onSelectedChanged: onSelectedChanged,
    groupType: groupType,
    setGroupType: setGroupType,
    createGroupTempData: createGroupTempData,
    setCreateGroupTempData: setCreateGroupTempData,
    groupsSelectorTempData: groupsSelectorTempData,
    setGroupsSelectorTempData: setGroupsSelectorTempData,
    studentsSelectorTempData: studentsSelectorTempData,
    setStudentsSelectorTempData: setStudentsSelectorTempData,
    getStudentsSearchList: getStudentsSearchList,
    saveGroup: saveGroup,
    createGroupErrorMessage: createGroupErrorMessage,
    cantRemoveMessage: cantRemoveMessage,
    setCantRemoveMessage: setCantRemoveMessage,
    view: view,
    viewIndex: viewIndex,
    setViewAndIndex: setViewAndIndex,
    isErrorMessage: isErrorMessage,
    onClose: onClose,
    onDisableItemClick: onDisableItemClick,
    onDeleteItem: onDeleteItem,
    fullHeight: fullHeight
  };
};
exports.useAudiencePickerProvider = useAudiencePickerProvider;